<template>
  <div class="l-item">
    <div class="t-serial t-sans"><p>{{shopitem.serial}}</p></div>
    <img :src='shopitem.image' @click="single(shopitem.id)">
    <h1 class="t-serif">{{shopitem.title}}</h1>
    <div class="author"><h2 class="t-sans">{{shopitem.author}}</h2></div>
    <p class="t-serif t-project">{{shopitem.description}}</p>
    <a @click="single(shopitem.id)" class="m-btn-more t-sans"><span>+</span></a>
    <template v-if="shopitem.trackList">
      <div class="track-list">
        <table>
          <tr v-for="track in shopitem.trackList" :key="track.id">
            <template v-if="playable(track)">
              <td class="play-track" @click="nextSong(track.title, track.trackUrl, track.author)">{{track.title}}</td>
              <td class="track-author">{{track.author}}</td>
            </template>
            <template v-else>
              <td class="no-play-track">{{track.title}}</td>
              <td class="track-author">{{track.author}}</td>
            </template>
          </tr>
        </table>
      </div>
    </template>
    <template v-if="shopitem.available">
      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
        <input type="hidden" name="cmd" value="_s-xclick">
        <input type="hidden" name="hosted_button_id" :value="shopitem.ppUrl">
        <input type="submit" :value="shopitem.stockMessage + '  |  £' + shopitem.price" class="m-btn-buy t-sans">
      </form>
    </template>
    <template v-else>
      <div class="m-btn-buy m-btn-out t-sans">{{shopitem.stockMessage}}</div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ShopItem',
  props: ['shopitem'],
  methods: {
    ...mapActions(['updatePlayer']),
    nextSong (title, url, author) {
      this.updatePlayer([title, url, author])
    },
    playable (payload) {
      if (payload.trackUrl !== '') {
        return true
      } else {
        return false
      }
    },
    single (id) {
      this.$router.push({ name: 'ShopSingle', params: { single: this.shopitem.serial } })
    }
  }
}
</script>

<style scoped lang='scss'>

.l-item {
    position: relative;
    max-width: 500px;
}

.l-images {
  width: 500px;
  background:red;
}

h1 {
  text-transform: uppercase;
  font-weight: normal;
}

.author {
  text-align: center;
  h2 {
    display: inline;
    background: #fff;
    border: 1px solid #000;
    color: #000;
    border-radius: 20px;
    padding: 8px 12px;
    font-size: 90%;
  }
}

.t-project {
  padding-top: 20px;
}

.t-serial {
  text-align: center;
  font-size: 1.2rem;
  position: sticky;
  top: 18px;
  p {
    opacity: 0.9;
    background: rgba(74, 255, 100, 0.9);
    color: #000;
    font-size: 0.75rem;
    display: inline;
    border-radius: 20px;
    padding: 5px 10px;
    box-shadow: 0px 0px 10px #f2f2f2;
  }
}

img {
  transition: filter 0.4s;
  cursor: pointer;
  &:hover {
    filter: blur(4px);
  }
}

form {
  position: sticky;
  bottom: 0px;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 50%);
  height: 50px;
}

.m-btn-out {
  cursor: not-allowed !important;
  &:hover {
    background: #f2f2f2 !important;
  }
}

.m-btn-more {
  color: #fff;
  cursor: pointer;
  border-radius: 60px;
  background: rgba(0,0,0,0.9);
  position: sticky;
  bottom: 60px;
  width: 25px;
  height: 25px;
  text-align:center;
  display: table;
  margin: 0 auto;
  font-size: 1.2rem;
  line-height: 1.5rem;
  transition: background 0.3s, color 0.3s;
  span {

  }

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #000;
    }
  }

  &:hover {
    color: #000;
    background: #4aff64;
  }
}

.m-btn-buy {
  color: #fff;
  cursor: pointer;
  border-radius: 20px;
  border: 1px solid #fff;
  background: rgba(0,0,0,0.9);
  position: sticky;
  text-align:center;
  bottom: 20px;
  padding: 8px 15px;
  display: table;
  margin: 0 auto;
  font-size: 0.8rem;
  transition: background 0.3s, color 0.3s;

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #000;
    }
  }

  span {
    margin: 0px 5px 0px 2px;
  }

  &:hover {
    color: #000;
    background: #4aff64;
  }
}

@media all and (max-width: 600px) {
  .l-item {
    max-width: none;
    border-bottom: 1px solid #000;
  }

  .m-btn-buy {
    margin-left: 36vw;
  }
  .track-list {
    padding-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShopItem.vue